<div class="modal-content">
  <div class="modal-header">
    <h4 class="title is-size-4" [translate]="title"></h4>
  </div>
  <div class="modal-body">
    <h6 class="title is-size-6" [translate]="subtitle"></h6>

    @if (isAidServiceActive) {
      <div [formGroup]="form" novalidate>
        <fino-checkbox
          formControlName="accessOnlyForAdmins"
          label="kwh.deactivate.accessOnlyForAdmins"
        ></fino-checkbox>

        <fino-checkbox
          class="mt-2"
          formControlName="activesGetCancelled"
          label="kwh.deactivate.activesGetCancelled"
        ></fino-checkbox>

        <fino-checkbox
          class="mt-2"
          formControlName="faxRedirect"
          label="kwh.deactivate.faxRedirect"
        ></fino-checkbox>
      </div>
    }

    <p
      [class.has-text-weight-bold]="isAidServiceActive"
      [innerHtml]="hint | translate"
    ></p>
  </div>
  <div class="modal-footer">
    <div class="is-flex is-centered">
      <button
        [primary]="true"
        type="button"
        class="has-text-weight-bold mr-1"
        [disabled]="form.invalid"
        (click)="submit()"
        fino-button
        [label]="submitLabel"
      ></button>

      <button
        type="button"
        (click)="abort()"
        class="ml-1"
        fino-button
        label="kws.deactivate.abort"
      ></button>
    </div>
  </div>
</div>
